module.exports = __webpack_public_path__ + "img/Ganoderma_lucidum.fbf8f5dc.jpg";